<template>
    <base-page
        title="材料处理完成"
        :pic="IMAGE_MAP.UPLOADED_PAGE_ICON"
    ></base-page>
</template>

<script>
import BasePage from './BasePage.vue';
import { getFixedImgUrl } from '@/utils/dynamic-cdn';
const IMAGE_MAP = getFixedImgUrl();
export default {
    name: 'uploaded-page',
    components: {
        BasePage,
    },
    data() {
        return {
            IMAGE_MAP,
        };
    },
};
</script>
